import { observer } from 'mobx-react-lite';
import { useStore } from '@/hooks/useStore';
import './index.scss';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '@/configs/constants';

export default observer(function LoadingApi() {
    // hook
    const { pathname } = useLocation();

    const isPricePage = pathname.includes(ROUTES.priceList.href);

    // store
    const {
        apiStore: { isLoading }
    } = useStore();

    return (
        isLoading ?
            (
                <div className='overlay-loading'>
                    {
                        !isPricePage && (
                            <div className='spinner center'>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                                <div className='spinner-blade'></div>
                            </div>
                        )
                    }

                </div>
            ) :
            (
                <></>
            )
    );
});
